import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import httpClient from 'http-client';
import ProgressBar from 'components/ProgressBar';
import { MainBtn } from 'components/Buttons';
import { getUserProgressUserTrail } from 'services/user';
import { getCourse, getAllCourses } from 'services/course';
import { User } from 'services/user/models/user-interface';
import { SectionContainer } from 'components/Container';

import {
  WelcomeTitleContainer,
  LastWatchedContainer,
  ImagTitleContainer,
  DashBlankBtn,
} from './style';
import PlayIconWhite from 'assets/icon/play-icon-white.svg';
import PlayIconWhiteOutline from 'assets/icon/icone-play-white.svg';
import PlayIconPink from 'assets/icon/icone-play.svg';
import Avatar from 'assets/icon/avatar.svg';

const Welcome: React.FC = () => {
  const [infoOverall, setInfoOverall] = useState<any>();
  const [user, setUser] = useState<User>();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      const localUserDetails = JSON.parse(
        localStorage.getItem('exeltis-user') as string,
      );
      setUser(localUserDetails);
      const progress = await getUserProgressUserTrail();

      if (progress && progress.length) {
        const localTrail = await getCourse(progress[0].trail_id);
        const sortCourse = localTrail.user.courses
          .filter(course => !!course.start_at && !!course.finish_at === false)
          .sort((a, b) => {
            let date1 = new Date(a.start_at);
            let date2 = new Date(b.start_at);

            if (date1 < date2) return 1;
            if (date1 > date2) return -1;
            return 0;
          });

        let lastCourse;

        if (sortCourse.length) {
          lastCourse = localTrail.courses.find(
            course => course.course_id === sortCourse[0].course_id,
          );
        }

        if (sortCourse && sortCourse.length) {
          let lastLessonProgress = sortCourse[0]?.contents
            .filter(lesson => !!lesson.start_at)
            .sort((a, b) => {
              let date1 = new Date(a.start_at);
              let date2 = new Date(b.start_at);

              if (date1 < date2) return 1;
              if (date1 > date2) return -1;
              return 0;
            });

          let lastLesson;

          if (lastCourse && lastLessonProgress && lastLessonProgress.length) {
            lastLesson = lastCourse.lessons.find(
              lesson => lesson.content_id === lastLessonProgress[0].content_id,
            );
          }

          if (lastLesson && lastCourse) {
            setInfoOverall({
              ...localUserDetails,
              progress: Math.round(progress[0].progress * 100),
              period: lastCourse.position,
              title: lastCourse.title,
              lesson_title: lastLesson?.title,
              trailId: localTrail.trail_id,
              courseId: lastCourse.course_id,
              lessonId: lastLesson?.content_id,
              thumbnail: lastLesson?.thumbnail,
            });
          }
        }
      } else {
        const allTrails = await getAllCourses();
        const localTrail = await getCourse(allTrails[0].trail_id);

        setInfoOverall({
          ...localUserDetails,
          trailId: localTrail.trail_id,
          courseId: localTrail.courses[0].course_id,
          lessonId: localTrail.courses[0].lessons[0]?.content_id,
        });
      }
    })();
  }, []);

  const sendWelcomeMail = async () => {
    const user = JSON.parse(localStorage.getItem('exeltis-user') as string);
    const dataUser = {
      email: user.email,
      name: user.name,
    };
    await httpClient.post('/users/sendMail', dataUser);
  };

  const handleStartCourse = async () => {
    // await sendWelcomeMail();
    history.push(
      `/trilha/${infoOverall?.trailId}/curso/${infoOverall?.courseId}/aula/${infoOverall?.lessonId}`,
    );
  };

  return (
    <React.Fragment>
      <SectionContainer>
        {infoOverall && infoOverall?.progress !== undefined ? (
          <WelcomeTitleContainer hasCourse>
            <div className="title-text">
              <ImagTitleContainer>
                <div className="avatar-container">
                  <img
                    src={user?.info?.avatar ? user.info.avatar : Avatar}
                    alt="avatar"
                  />
                </div>
                <div>
                  <h1>Olá, {user?.name}</h1>

                  <h3>
                    Acompanhe o seu progresso no curso de Gestante reGegenesis.
                  </h3>
                </div>
              </ImagTitleContainer>

              <div>
                <h4>{infoOverall?.title}</h4>

                <p>{infoOverall?.lesson_title}</p>
              </div>

              <div className="bar">
                <ProgressBar
                  progress={infoOverall?.progress}
                  hasTitle
                  message="DO CURSO"
                />
              </div>
            </div>

            <LastWatchedContainer>
              <div className="watched-info">
                <div className="image-container">
                  <img
                    src={infoOverall.thumbnail}
                    alt="Vídeo"
                    onClick={() =>
                      history.push(
                        `/trilha/${infoOverall?.trailId}/curso/${infoOverall?.courseId}/aula/${infoOverall?.lessonId}`,
                      )
                    }
                  />
                  <div className="overlay"></div>
                  <img
                    className="play-icon"
                    src={PlayIconWhiteOutline}
                    alt="Play"
                  />
                </div>

                <div className="container-btn">
                  <DashBlankBtn
                    onClick={() =>
                      history.push(
                        `/trilha/${infoOverall?.trailId}/curso/${infoOverall?.courseId}/aula/${infoOverall?.lessonId}`,
                      )
                    }
                  >
                    <img src={PlayIconPink} alt="play" /> continuar de onde
                    parei
                  </DashBlankBtn>
                </div>
              </div>
            </LastWatchedContainer>
          </WelcomeTitleContainer>
        ) : (
          <WelcomeTitleContainer hasCourse={false}>
            <div className="title-text">
              <ImagTitleContainer>
                <div className="avatar-container">
                  <img
                    src={user?.info?.avatar ? user.info.avatar : Avatar}
                    alt="avatar"
                  />
                </div>
                <div>
                  <h1>Olá, {user?.name}!</h1>

                  <h3>Seja bem-vinda ao Curso de Gestante reGenesis.</h3>
                </div>
              </ImagTitleContainer>

              <p>
                Aqui você terá acesso a um curso completo que vai te acompanhar
                por toda a jornada da gestação até os
                <span> 6 meses de vida do seu bebê. </span>
              </p>

              <br />

              <p>
                Sabemos o quão importante é a <span>rede de apoio</span> neste
                momento único da vida. Por isso, trouxemos vários
                <span> profissionais da saúde</span> para te orientar com
                segurança e carinho neste gestar!
              </p>
            </div>

            {infoOverall && (
              <MainBtn onClick={handleStartCourse}>
                <img src={PlayIconWhite} alt="play" /> iniciar curso
              </MainBtn>
            )}
          </WelcomeTitleContainer>
        )}
      </SectionContainer>
    </React.Fragment>
  );
};

export default Welcome;
